import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import SizeTable from 'components/common/size-table'
import { MEASUREMENT_TYPE } from 'components/pdp/interactions/measurements/const'
import {
  getTableColumns,
  getTableRows,
} from 'components/pdp/interactions/measurements/utils'
import { withI18next } from 'lib/i18n/withI18next'

const ConversionTable = ({ product, simplifiedSpec, t, sizeHeader }) => {
  const { attributes, is_new_size_method: isNewSize = false } = product

  const rows = useMemo(
    () =>
      getTableRows(attributes, t, MEASUREMENT_TYPE.shoe, false, simplifiedSpec),
    [attributes, simplifiedSpec, t],
  )
  const columns = useMemo(
    () => getTableColumns(rows, sizeHeader),
    [rows, sizeHeader],
  )

  return (
    <div className="pdp-measurements__table for-shoe">
      <SizeTable columns={columns} rows={rows} isNewSize={isNewSize} isPhone />
    </div>
  )
}

ConversionTable.defaultProps = { sizeHeader: null }

ConversionTable.propTypes = {
  sizeHeader: PropTypes.shape({
    key: PropTypes.string,
    title: PropTypes.string,
    titleKey: PropTypes.string,
  }),
  internationalization: PropTypes.shape({
    country: PropTypes.string,
  }).isRequired,
  product: PropTypes.shape({
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        measurements: PropTypes.arrayOf(
          PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string,
            value_in: PropTypes.string,
          }),
        ),
      }),
    ),
    is_new_size_method: PropTypes.bool,
    measurement_spec: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        is_fix_unit: PropTypes.bool,
      }),
    ),
  }).isRequired,
  simplifiedSpec: PropTypes.shape({}).isRequired,
  t: PropTypes.func.isRequired,
}

export default withI18next()(ConversionTable)
